"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.assetElementsBuilder = exports.AssetElementsBuilder = void 0;
class AssetElementsBuilder {
    taxonomyElement(element) {
        return element;
    }
}
exports.AssetElementsBuilder = AssetElementsBuilder;
exports.assetElementsBuilder = new AssetElementsBuilder();
//# sourceMappingURL=asset-elements.builder.js.map